
/*
 * ! @chakra-ui/vue v0.13.1 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { R as createStyledAttrsMixin, a as pickProperty } from './index-2216d089.js';
import './chakra-ui-styled-system.esm-a8a2e91f.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-de5da461.js';
import { u as useInputStyle } from './input.styles-382a5002.js';

/**
 * Hey! Welcome to @chakra-ui/vue InputAddon
 *
 * InputAddon allows addition of addons to the left and right of the CInput component
 *
 * @see Docs     https://vue.chakra-ui.com/input
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CInputAddon/CInputAddon.js
 */
var addonProps = {
  placement: {
    type: String,
    default: 'left'
  },
  size: {
    type: String,
    default: 'md'
  }
};
/**
 * CInputAddon component
 *
 * allows addition of addons to the left and right of the CInput component
 *
 * @extends CBox
 * @see Docs https://vue.chakra-ui.com/input
 */

var CInputAddon = {
  name: 'CInputAddon',
  mixins: [createStyledAttrsMixin('CInputAddon')],
  props: addonProps,
  computed: {
    componentStyles: function componentStyles() {
      var bg = {
        dark: 'whiteAlpha.300',
        light: 'gray.100'
      };
      var _placement = {
        left: {
          mr: '-1px',
          roundedRight: 0,
          borderRightColor: 'transparent'
        },
        right: {
          order: 1,
          roundedLeft: 0,
          borderLeftColor: 'transparent'
        }
      };
      return Object.assign({}, useInputStyle({
        size: this.size,
        variant: 'outline',
        colorMode: this.colorMode,
        theme: this.theme
      }), {
        flex: '0 0 auto',
        whiteSpace: 'nowrap',
        bg: bg[this.colorMode]
      }, _placement[this.placement]);
    }
  },
  render: function render(h) {
    return h(this.as, {
      class: [this.className],
      attrs: this.computedAttrs,
      on: this.computedListeners
    }, this.$slots.default);
  }
};
/**
 * CInputLeftAddon component
 *
 * allows addition of addons to the left of CInput component
 *
 * @extends CInputAddon
 * @see Docs https://vue.chakra-ui.com/input
 */

var CInputLeftAddon = {
  name: 'CInputLeftAddon',
  functional: true,
  props: addonProps,
  render: function render(h, ref) {
    var props = ref.props;
    var slots = ref.slots;
    var data = ref.data;
    return h(CInputAddon, {
      props: Object.assign({}, pickProperty(props), {
        placement: 'left'
      }),
      attrs: Object.assign({}, data.attrs, {
        'data-chakra-component': 'CInputLeftAddon'
      })
    }, slots().default);
  }
};
/**
 * CInputRightAddon component
 *
 * allows addition of addons to the right of CInput component
 *
 * @extends CInputAddon
 * @see Docs https://vue.chakra-ui.com/input
 */

var CInputRightAddon = {
  name: 'CInputRightAddon',
  functional: true,
  props: addonProps,
  render: function render(h, ref) {
    var props = ref.props;
    var slots = ref.slots;
    var data = ref.data;
    return h(CInputAddon, {
      props: Object.assign({}, pickProperty(props), {
        placement: 'right'
      }),
      attrs: Object.assign({}, data.attrs, {
        'data-chakra-component': 'CInputRightAddon'
      })
    }, slots().default);
  }
};

export default CInputAddon;
export { CInputLeftAddon, CInputRightAddon };
